/**
 * [充值]
 * @Author: Fu Xiaochun
 * @Email:  f2e.xiaochun@gmail.com
 */

import React, { useState, useEffect } from 'react';
import styles from './modal.module.scss';
import { Modal, Form, Input, Button, Select, InputNumber, message } from 'antd';
import { regFenToYuan, regYuanToFen, priceUppercase } from '@/util/money';
import * as apis from '@/apis/finance/platformAccount';

function RechargeModal(props){

    const accounts = [{value: '2527263571630374', label: '2527263571630374(收益账户)'}];

    const [toAccount, setToAccount] = useState({value: '2527263571630374'});
    const [amount, setAmount] = useState();
    const [remark, setRemark] = useState();

    const onClose = ()=>{
        props.onClose();
    };

    const onSubmit = ()=>{
        if(!amount){
            message.error('请输入提现金额');
            return false;
        }

        let formData = {
            amount: regYuanToFen(amount),
            remark,
        };
        apis.lianlianServiceRecharge(formData).then(res=>{
            message.success('操作成功');
            props.onOk();
        }).catch(err=>{
            message.error(err.message);
        });
        props.onOk();
    };

    const onRemarkChange = (e)=>{
        let val = e.target.value || '';
        val = val.trim();
        setRemark(val);
    };

    return <>
        <Modal visible={true} centered title="收益户充值" width="700px" onOk={onSubmit} onCancel={onClose}>
            <div className={styles.formBox}>
                <div className={styles.formItem}>
                    <div className={styles.label}>充值账户：</div>
                    <div className={styles.val}>2527263571697274</div>
                </div>
                <div className={styles.formItem}>
                    <div className={styles.label}>当前余额：</div>
                    <div className={styles.val}>{regFenToYuan(props.balance)}</div>
                </div>
                <div className={styles.formItem}>
                    <div className={styles.label}>转出账户：</div>
                    <div className={styles.val}>
                        <Select className={styles.txt} labelInValue value={toAccount} options={accounts}/>
                    </div>
                </div>
                <div className={styles.formItem}>
                    <div className={styles.label}>充值金额：</div>
                    <div className={styles.val}>
                        <InputNumber className={styles.txt} placeholder="请输入充值金额" min={0} precision={2} value={amount} onChange={setAmount} />
                        <p>金额大写：{priceUppercase(amount)}</p>
                    </div>
                </div>
                <div className={styles.formItem}>
                    <div className={styles.label}>充值留言：</div>
                    <div className={styles.val}>
                        <Input.TextArea className={styles.txts} placeholder="请输入充值留言或原因" value={remark} onChange={onRemarkChange}></Input.TextArea>
                    </div>
                </div>
            </div>
        </Modal>
    </>
}

export default RechargeModal;